exports.serviceTeam="giants";
exports.serviceType="info";
exports.authServerHost = `${process.env.REACT_APP_AUTH_API_URL}`;